import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "col-12 col-md-8 col-lg-6" }
const _hoisted_3 = { class: "mt-4 form-check form-switch me-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = ["disabled"]

import { ref, computed } from 'vue';
import { useStore } from "vuex";
import { app } from "@/guiide/ts/app";
import TextInput from "@/guiide/components/common/TextInput.vue";
import Constants from "@/guiide/ts/constants";
import DynamicAdviceViewer from "@/guiide/components/common/DynamicAdviceViewer.vue";
import ConsentType from "@/guiide/ts/consent/consentType";
import ExternalAgency from "@/guiide/ts/consent/externalAgency";
import PermittedEntityType from "@/guiide/ts/consent/permittedEntityType";
import { hasConsented } from "@/guiide/ts/utilities";
import Result from "@/guiide/ts/result";
import { useUIContent } from '@/guiide/ts/configuration/useUIContent';


export default /*@__PURE__*/_defineComponent({
  __name: 'NextStepIFA',
  setup(__props) {

const store = useStore();
const { templateTextArray } = useUIContent();

const nameInput = ref(null);
const nameModel = ref("");
const phoneInput = ref(null);
const phoneNumberModel = ref("");
const emailInput = ref(null);
const emailModel = ref("");

const consentToggleDisabled = computed<boolean>(() => store.state.transactionOngoing);

const hasConsentedToPrivacyNotice = computed<boolean>(() => hasConsented(ExternalAgency.Aon, ConsentType.PrivacyNoticeAccepted));
const privacyConsent = ref(hasConsentedToPrivacyNotice.value);

const disableSubmit = ref<boolean>(!hasConsentedToPrivacyNotice.value);

const submissionError = ref("");
const submissionSuccessMessage = ref("");

const showContent = ref(true);

const ifa = computed(() => store.state.retiree.finalSalaries.schemes[0].linkedIfas[0].name);

async function handleConsentToggle() {
    disableSubmit.value = true;

    let consented = privacyConsent.value;

    let toggleConsentResult: Result;
    if (consented) {
        toggleConsentResult = await app.grantConsent(PermittedEntityType.ExternalAgency, ExternalAgency.Aon, ConsentType.PrivacyNoticeAccepted, true);
    } else {
        toggleConsentResult = await app.revokeConsent(PermittedEntityType.ExternalAgency, ExternalAgency.Aon, ConsentType.PrivacyNoticeAccepted);
    }

    if (toggleConsentResult.successful) {
        disableSubmit.value = !consented;
    } else {
        submissionError.value = "Failed to save change.";
    }
}

async function onBookSessionClicked() {
    submissionError.value = "";

    if (!nameInput.value.isValid()) {
        submissionError.value = "Invalid name.";
        return;
    }
    if (!phoneInput.value.isValid()) {
        submissionError.value = "Invalid phone number.";
        return;
    }
    if (!emailInput.value.isValid()) {
        submissionError.value = "Invalid email address.";
        return;
    }

    if (!hasConsentedToPrivacyNotice.value) {
        submissionError.value = "Please confirm you agree to Aon sharing your information.";
        return;
    }

    var ifaId = store.state.retiree.finalSalaries.schemes[0].linkedIfas[0].id;
    const result = await app.requestFinancialAdvice(nameModel.value, emailModel.value, phoneNumberModel.value, ifaId);

    if (!result.successful) {
        submissionError.value = result.message;
    } else {
        showContent.value = false;
        submissionSuccessMessage.value = "Request sent.";
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "mb-3" }, "I'm looking for financial advice", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateTextArray)('dboptions.next-steps.ifa.introduction.body', { ifa: ifa.value }), (text, i) => {
      return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(text), 1))
    }), 128)),
    (showContent.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(TextInput, {
              ref_key: "nameInput",
              ref: nameInput,
              modelValue: nameModel.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameModel).value = $event)),
              description: "Name",
              class: "mt-4"
            }, null, 8, ["modelValue"]),
            _createVNode(TextInput, {
              ref_key: "phoneInput",
              ref: phoneInput,
              modelValue: phoneNumberModel.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumberModel).value = $event)),
              description: "Phone number",
              regex: _unref(Constants).RegularExpressions.PhoneNumber,
              "key-press-regex": _unref(Constants).RegularExpressions.PhoneNumberChars,
              maxlength: "20",
              class: "mt-4"
            }, null, 8, ["modelValue", "regex", "key-press-regex"]),
            _createVNode(TextInput, {
              ref_key: "emailInput",
              ref: emailInput,
              modelValue: emailModel.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((emailModel).value = $event)),
              description: "Email",
              regex: _unref(Constants).RegularExpressions.Email,
              "key-press-regex": _unref(Constants).RegularExpressions.EmailChars,
              class: "mt-4"
            }, null, 8, ["modelValue", "regex", "key-press-regex"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              id: "consentToPrivacyNotice",
              type: "checkbox",
              class: "form-check-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((privacyConsent).value = $event)),
              role: "switch",
              onChange: handleConsentToggle,
              disabled: consentToggleDisabled.value
            }, null, 40, _hoisted_4), [
              [_vModelCheckbox, privacyConsent.value]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              class: "form-check-label ms-3 fw-bold",
              for: "consentToPrivacyNotice"
            }, [
              _createTextVNode(" I confirm I have read Aon's "),
              _createElementVNode("a", {
                href: "https://www.aon.com/unitedkingdom/retirement-investment/retirement-investment-services-privacy-statement.jsp",
                target: "_blank"
              }, "Privacy Notice"),
              _createTextVNode(" and agree to Aon sharing my information with the IFA for the purposes of contacting me and providing advice. ")
            ], -1))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mt-4" }, [
            _createElementVNode("p", { class: "fst-italic" }, [
              _createTextVNode(" By submitting this form you are confirming that you have read Aon's Privacy Notice and agree to your data being shared with the IFA. The IFA will contact you directly. Aon processes your personal data in line with our privacy obligation under the Data Protection Act. For more details please see the privacy notice "),
              _createElementVNode("a", {
                href: "https://www.aon.com/unitedkingdom/retirement-investment/retirement-investment-services-privacy-statement.jsp",
                target: "_blank"
              }, "here"),
              _createTextVNode(". ")
            ])
          ], -1)),
          _createVNode(DynamicAdviceViewer, {
            message: submissionError.value,
            alertContext: "danger"
          }, null, 8, ["message"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-book",
              onClick: onBookSessionClicked,
              disabled: disableSubmit.value
            }, "Submit", 8, _hoisted_6)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(DynamicAdviceViewer, {
      message: submissionSuccessMessage.value,
      alertContext: "success"
    }, null, 8, ["message"])
  ], 64))
}
}

})